import type { TPersonalType } from "@/types"
import { shirtSizes } from "@/utils/constants"
import { AnswerCity } from "./AnswerCity"
import { AnswerDate } from "./AnswerDate"
import { AnswerSelect } from "./AnswerSelect"
import { AnswerUser } from "./AnswerUser"
import type { IAnswerProps } from "./types"

export function AnswerPersonal(props: IAnswerProps) {
  const { question } = props
  const category = question.meta.category as TPersonalType
  if (category == "city") return <AnswerCity {...props} />
  if (category == "manager") return <AnswerUser {...props} />
  if (category == "birthday" || category == "start_date") return <AnswerDate format="D MMMM" {...props} />
  if (category == "size") return <AnswerSelect {...props} choices={shirtSizes} />

  return null
}
